jQuery(document).ready(function ($) {
  const socials = document.querySelectorAll(".social");

  if (socials) {
    const socialShare = (socialPlatform) => {
      let postUrl = window.location.href;
      let url;

      if (socialPlatform === "Facebook") {
        url =
          "https://www.facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent(postUrl);
      } else if (socialPlatform === "Twitter") {
        let text = "Check out this amazing post!";
        url =
          "https://twitter.com/intent/tweet?url=" +
          encodeURIComponent(postUrl) +
          "&text=" +
          encodeURIComponent(text);
      } else if (socialPlatform === "Email") {
        let subject = "Check out this amazing post!";
        let body = "I thought you might be interested in this: " + postUrl;
        url =
          "mailto:?subject=" +
          encodeURIComponent(subject) +
          "&body=" +
          encodeURIComponent(body);
        window.location.href = url;
        return;
      }
      window.open(
        url,
        socialPlatform.toLowerCase() + "-share-dialog",
        "width=800,height=600"
      );
    };

    $("#Facebook").click(function (e) {
      e.preventDefault();
      socialShare("Facebook");
    });

    $("#Twitter").click(function (e) {
      e.preventDefault();
      socialShare("Twitter");
    });

    $("#Email").click(function (e) {
      e.preventDefault();
      socialShare("Email");
    });
  }
});
